import baseRequest from './baseRequest';
export default (args) => baseRequest({
  endpoint: "entityleads",
  route:"getSumSentBySubentityIdWithChildren",
  data: {args: JSON.stringify(args)},
  method: "GET"
});
